module.exports = __webpack_public_path__ + "static/Advantage05@2x.1672d74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage05@2x.png
// module id = 696
// module chunks = 216210090109534